export class TimelineRefreshError extends Error {
    constructor(
        readonly entity: string,
        readonly cause: unknown
    ) {
        super(`Failed to refresh ${entity} timeline data`);
        this.name = 'TimelineRefreshError';
    }
}
